<kt-portlet>
  <!-- PORTLET LOADING | Binded to TABLE Datasource -->
  <!-- See prop => '~/core/_crud/models/data-sources/_base.datasource.ts' (loading$) -->
  <kt-portlet-header
    title="{{ 'TABLE.AFFILIATION_TYPE_LIST' | translate }}"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddAffiliationType">
          <button
            (click)="addAffiliationType()"
            mat-raised-button
            matTooltip="Create new Practition role"
            color="primary"
            type="button"
            class="margin-2"
          >
            <span class="svg-icon-md" translate>
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              {{ 'TABLE.ADD_AFFILIATION_TYPE' | translate }}</span
            >
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <kt-portlet-body>
    <!-- start::FILTERS & GROUP ACTIONS -->
    <div class="form kt-margin-b-30">
      <!-- start::FILTERS -->
      <div class="form-filtration">
        <div class="row align-items-center">
          <div class="col-md-2 kt-margin-bottom-10-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
              <input
                matInput
                placeholder="{{ 'TABLE.SEARCH' | translate }}"
                #searchInput
                placeholder="Search"
              />
              <mat-hint align="start">
                <strong>{{ 'TABLE.SEARCH' | translate }}</strong>
                {{ 'TABLE.IN_ALL_FIELDS' | translate }}
              </mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="mat-table-wrapper">
      <mat-table
        class="lmat-elevation-z8"
        #table
        [dataSource]="dataSource"
        matSort
        #sort1="matSort"
        matSortActive="id"
        matSortDirection="desc"
        matSortDisableClear
      >
        <ng-container matColumnDef="affiliation_type_name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name </mat-header-cell>
          <mat-cell *matCellDef="let affiliationType">
            {{ affiliationType.affiliation_type_name }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="affiliation_type_description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Description </mat-header-cell>
          <mat-cell *matCellDef="let affiliationType">
            {{ affiliationType.affiliation_type_description }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let affiliationType">
            <ng-template ngxPermissionsOnly="canEditAffiliationType">
              <button
                color="primary"
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Affiliation Type"
                (click)="updateAffiliationType(affiliationType)"
                class="btn btn-icon btn-light btn-hover-primary btn-sm margin-2"
              >
                <span class="svg-icon svg-icon-md svg-icon-primary">
                  <span inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"></span>
                </span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteAffiliationType">
              <button
                color="danger"
                matTooltip="{{ 'TABLE.DELETE' | translate }} Affiliation Type"
                (click)="deleteAffiliationType(affiliationType)"
                class="btn btn-icon btn-light btn-hover-danger btn-sm margin-2"
              >
                <span class="svg-icon svg-icon-md svg-icon-danger">
                  <span inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"></span>
                </span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table__message" *ngIf="!dataSource.hasItems">
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <!-- Message for empty data  -->
      <div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom">
      <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <!-- MATERIAL PAGINATOR | Binded to dasources -->
      <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
    <!-- end: BOTTOM -->
  </kt-portlet-body>
  <!-- end::Body -->
</kt-portlet>
